import { render, staticRenderFns } from "./FieldOrador.vue?vue&type=template&id=70c8a08c"
import script from "./FieldOrador.vue?vue&type=script&lang=js"
export * from "./FieldOrador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports